import * as React from 'react'

import { StatusLabel } from '@factorialco/deprecated-design-system'
import { ProcurementValueObjectsPurchaseRequestStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  status: ProcurementValueObjectsPurchaseRequestStatusEnum
}

export const getPurchaseRequestStatusLabel = (
  status: ProcurementValueObjectsPurchaseRequestStatusEnum
) => {
  const statusInfo: Record<
    ProcurementValueObjectsPurchaseRequestStatusEnum,
    { type: React.ComponentProps<typeof StatusLabel>['type']; label: string }
  > = {
    ['approved']: {
      type: 'positive',
      label: i18n.t('procurement.purchase_requests.status.approved'),
    },
    ['draft']: {
      type: 'warning',
      label: i18n.t('procurement.purchase_requests.status.draft'),
    },
    ['pending']: {
      type: 'warning',
      label: i18n.t('procurement.purchase_requests.status.pending'),
    },
    ['rejected']: {
      type: 'critical',
      label: i18n.t('procurement.purchase_requests.status.rejected'),
    },
  }

  return statusInfo[status]
}

export const SpendingRequestStatusLabel = ({ status }: Props) => {
  const { type, label } = getPurchaseRequestStatusLabel(status)

  return <StatusLabel type={type}>{label}</StatusLabel>
}
